export const CHANGE_PRODUCT_SUCCESS = 'CHANGE_PRODUCT_SUCCESS'
export const CHANGE_PRODUCT_FILTER_SUCCESS = 'CHANGE_PRODUCT_FILTER_SUCCESS'
export const CHANGE_PRODUCT_DATA_FOR_HEADER_DROPDOWN = 'CHANGE_PRODUCT_DATA_FOR_HEADER_DROPDOWN'
